/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Outside_StockInputs */

const en_scene_outside_stock = /** @type {(inputs: Scene_Outside_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available stock`)
};

/**
* | output |
* | --- |
* | "Available stock" |
*
* @param {Scene_Outside_StockInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_outside_stock = /** @type {((inputs?: Scene_Outside_StockInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Outside_StockInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_outside_stock(inputs)
});